module.exports = __webpack_public_path__ + "img/header-memoireRings@2x.4089819.jpg";